import Paper from '@mui/material/Paper'
import type { DataOrPromise, GenericRow, Options } from './types'
import type { Column } from './types'
import { DataManager, DataManagerProvider } from './DataManager'
import Box from '@mui/material/Box'
import { SxProps } from '@mui/system'

export type TableContentProps<RowType extends GenericRow> = {
  columns: Column<RowType>[]
  data: DataOrPromise<RowType>
  options: Options
  sx?: SxProps
  onChangeColumns?: (columns: Column<RowType>[]) => void
  dataManagerRef?: React.Ref<DataManager<RowType>>
  onChange?: () => void
  hasTabNavigation?: boolean
  children: React.ReactNode
}

export default function TableContainer<RowType extends GenericRow>({
  columns,
  data,
  options,
  sx = null,
  onChangeColumns,
  dataManagerRef = null,
  onChange,
  hasTabNavigation=false,
  children,
}: TableContentProps<RowType>
) {
  return (
    <DataManagerProvider columns={columns} data={data} options={options} onChangeColumns={onChangeColumns} dataManagerRef={dataManagerRef} onChange={onChange}>
      { hasTabNavigation &&
        <Box sx={{pt: 4, pb: 6, display: 'flex', flexDirection: 'column', minHeight: 0, ...sx}}>
          {children}
        </Box>
      ||
        <Paper sx={{p: '25px 30px', display: 'flex', flexDirection: 'column', minHeight: 0, ...sx}}>
          {children}
        </Paper>
      }
    </DataManagerProvider>
  )
}
